import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.map";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/InputGroup/input-group';
import { css } from '@patternfly/react-styles';
import { FormSelect } from '../FormSelect';
import { TextArea } from '../TextArea';
import { TextInput } from '../TextInput';
export var InputGroup = function InputGroup(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  var formCtrls = [FormSelect, TextArea, TextInput].map(function (comp) {
    return comp.toString();
  });
  var idItem = React.Children.toArray(children).find(function (child) {
    return !formCtrls.includes(child.type.toString()) && child.props.id;
  });
  return React.createElement("div", Object.assign({
    className: css(styles.inputGroup, className)
  }, props), idItem ? React.Children.map(children, function (child) {
    return formCtrls.includes(child.type.toString()) ? React.cloneElement(child, {
      'aria-describedby': idItem.props.id
    }) : child;
  }) : children);
};
InputGroup.displayName = 'InputGroup';